import React, { useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CONDITION_TYPE } from '../../../../constants/defaults';
import _ from 'lodash';

const SearchDropdown = props => {
  let {
    setSubmitId,
    submitId,
    noDrugFound,
    listItems = [],
    type,
    drugSuggestionDropdown,
    drug,
    isFromLocationSearch = false,
    handleSelectedCity = () => {}
  } = props;
  const listItemRefs = useRef([]);

  useEffect(() => {
    if (isFromLocationSearch) {
      if (submitId == null) {
        setSubmitId(0);
      } else if (submitId !== 0 && listItemRefs?.current[submitId]) {
        listItemRefs?.current[submitId]?.focus();
        listItemRefs?.current[submitId]?.scrollIntoView({
          block: 'nearest',
          behavior: 'smooth'
        });
      }
    }
  }, [submitId]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeydownEvent);

    return () => {
      document.removeEventListener('keydown', handleKeydownEvent);
    };
  });

  const handleKeydownEvent = (event = { preventDefault() {} }) => {
    if (event.key === 'ArrowUp') {
      const prevId = submitId === 0 ? listItems.length - 1 : submitId - 1;
      setSubmitId(prevId);
    }
    if (event.key === 'ArrowDown') {
      const nextId = submitId === listItems.length - 1 ? 0 : submitId + 1;
      setSubmitId(nextId);
    }
    if (event.key === 'Enter') {
      if (event.target.value) {
        event.preventDefault();
        handleSubmit(submitId);
      }
    }
  };

  const getRouteByType = (type, slug) => {
    const routes = {
      condition: '/conditions',
      drug: '/drug-classes',
      [CONDITION_TYPE.CAUSE]: '/conditions',
      [CONDITION_TYPE.SYMPTOM]: '/conditions'
    };
    return `${routes[type]}/${slug}`;
  };

  const handleSubmit = id => {
    if (isFromLocationSearch) {
      handleSelectedCity(listItems[id]);
    } else if (!noDrugFound) {
      let item = listItems[id];
      if (item && item.slug) {
        window.location.assign(getRouteByType(type, item.slug));
      }
    }
  };

  const buildSuggestionTitle = item => {
    return isFromLocationSearch
      ? `${item.city + ', ' + item.state}`
      : type === 'condition'
      ? item.title
      : type === 'drug'
      ? item.name
      : item.title;
  };

  const renderSuggestionsList = () => {
    return listItems.map((item, id) => {
      return (
        <li
          key={id}
          id={`option-${id}`}
          className={`listItem ${id === submitId && 'active'}`}
          onClick={() => handleSubmit(id)}
          ref={listitem => (listItemRefs.current[id] = listitem)}
          aria-label={buildSuggestionTitle(item)}
          role="option"
          aria-selected={submitId === id}
        >
          {buildSuggestionTitle(item)}
        </li>
      );
    });
  };
  return (
    <div>
      <div className="site-search-results">
        {drugSuggestionDropdown && (
          <div
            id="search-results"
            aria-haspopup="listbox"
            className={'site-search-results--query  home-result'}
          >
            <article className="listContainer">
              <ul id="site-search-results" className="list" role="listbox">
                {renderSuggestionsList()}
              </ul>
            </article>
          </div>
        )}

        {noDrugFound && !_.isEmpty(drug) ? (
          <div
            id="site-search-results"
            className={'site-search-results--query'}
          >
            <article>
              <ul>
                <li className="note-error">
                  <span className="note">
                    Oops, there are no results for the term &#34;
                    <strong>{drug}</strong>&#34;
                  </span>
                </li>
              </ul>
            </article>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

SearchDropdown.propTypes = {
  listItems: PropTypes.array,
  drugSuggestionDropdown: PropTypes.bool,
  noDrugFound: PropTypes.bool,
  drug: PropTypes.string,
  setSubmitId: PropTypes.func,
  submitId: PropTypes.number,
  type: PropTypes.string
};

SearchDropdown.defaultProps = {
  listItems: [],
  drugSuggestionDropdown: false,
  noDrugFound: false,
  drug: '',
  setSubmitId: () => {},
  type: ''
};

export default withRouter(SearchDropdown);
